import { InputNumber } from 'antd';
import React from 'react';

export const LCInputNumber = props => <InputNumber {...props} />;
